import { useAdminAutoTradeSetup } from '_hooks/useAdminAutoTradeSetup'
import { UrlHelper } from '_utils/UrlHelper';
import { ErrorMessage } from 'components/common/ErrorMessage';
import { Spinner } from 'components/common/Spinner';
import { AutoTradeSetupStatusEnum, IAutoTradeSetup, AutoTradeSetupStatusEnumHelper } from 'predictagram-lib';
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { adminAutoTradeSetupService } from 'services/AdminApiService';

export const TradeSetupListPage:React.FunctionComponent = () => {

  const api = useAdminAutoTradeSetup(null);
  const navigate = useNavigate();

  const [selectedIds, setSelectedIds] = useState<number[]>([]);

  if (api.apiState.isError) {
    return <ErrorMessage className='bg-white'>{api.error}</ErrorMessage>
  }

  if (api.apiState.isLoading) {
    return <Spinner />
  }

  const handleEdit = (id: number) => {
    navigate(UrlHelper.getAdminAutoTradeSetupEdit(id));
  }

  const handleShowTrade = (setupId?: number) => {
    navigate(UrlHelper.getAdminAutoTrades(setupId))
  }

  const handleSelected = (id: number) => {
    if (selectedIds.includes(id)) {
      setSelectedIds(selectedIds.filter(i=>i !== id));
      return;
    }
    setSelectedIds([
      ...selectedIds,
      id
    ])
  }


  const handleSelect = async (statusId: AutoTradeSetupStatusEnum) => {
    try {
      const updatePromises = selectedIds.map((id) => adminAutoTradeSetupService.update({ statusId } as IAutoTradeSetup, id));
      await Promise.all(updatePromises);
      api.setFilter(Date.now()); // refreshes the dataset
      setSelectedIds([]);
    } catch (error: any) {
        console.error(error);            
    }
  }

  if (api.apiState.isLoaded) {
    return <div>
      <div className="page-title mb-3">Trade Setups</div>

      <div className="d-flex gap-3 my-3">
        <button className="btn btn-primary" onClick={()=>handleSelect(AutoTradeSetupStatusEnum.PAUSED)}>Pause Selected Setups</button>
        <button className="btn btn-primary" onClick={()=>handleSelect(AutoTradeSetupStatusEnum.PAUSED_ENTRY)}>Pause Selected Setups Entry</button>
        <button className="btn btn-primary" onClick={()=>handleSelect(AutoTradeSetupStatusEnum.PAUSED_EXIT)}>Pause Selected Setups Exit</button>
        <button className="btn btn-primary" onClick={()=>handleSelect(AutoTradeSetupStatusEnum.ACTIVE)}>Activate Selected Setups</button>
      </div>
      <div className="fixed-table-head">
      <table className="table table-striped table-hover">
        <thead>
          <tr>
            <th>Select</th>
            <th>ID</th>
            <th>Name</th>
            {/* <th>Emails for Alerts</th> */}
            <th>Symbol</th>
            <th className="text-end">Max Active Trades</th>
            <th className="text-end">Quantity per Trade</th>
            <th className="text-end">Trades Open</th>
            {/*<th>Side</th>*/}
            <th>Order Type</th>
            <th>Status</th>
            <th>Edit</th>
            <th>Show Trades</th>
          </tr>
        </thead>
        <tbody>
          {api.data.map((item, index) => <tr key={`item-${item.id}`}>
            <td>
            <button
              className={`btn btn-${selectedIds.includes(item.id) ? 'primary' : 'secondary'}`}
              onClick={(e: React.MouseEvent<HTMLElement>) => {
                e.stopPropagation();
                handleSelected(item.id);
              }}
            >
              {selectedIds.includes(item.id) ? 'Deselect' : 'Select'}
            </button>
            </td>
            <td>{item.id}</td>
            <td>{item.name}</td>
            <td className="text-end">{item.analysisSetup.stockSymbolId}</td>
            <td className="text-end">{item.maxActiveTrades}</td>
            <td className="text-end">{item.quantityPerTrade}</td>
            <td className="text-end">{item.tradesOpen}</td>
            {/*<td>{item.tradeTemplate.ibkr?.side}</td>*/}
            <td>{item.tradeTemplate.ibkr?.orderType}</td>
            <td>{AutoTradeSetupStatusEnumHelper.names.get(item.statusId)}</td>
            <td><button type="button" className="btn btn-primary" onClick={()=>handleEdit(item.id)}>Edit</button></td>
            {/* <td><button type="button" className="btn btn-primary">Delete</button></td> */}
            <td><button type="button" className={`btn btn-primary`} onClick={()=>handleShowTrade(item.id)}>Show Trades</button></td>
          </tr>)}
          <tr>

          </tr>
        </tbody>
      </table>
      </div>
      {/* <pre>{JSON.stringify(api.data, null, 2)}</pre> */}

    </div>
  }
  return <></>
}

